import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from 'utils/axiosBaseQuery';

export const statusTypeApi = createApi({
  reducerPath: 'statusTypeApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['statusType'],
  keepUnusedDataFor: 0,
  endpoints: (builder) => ({
    getStatusTypeList: builder.query({
      query: () => ({
        method: 'GET',
        path: 'StatusTypes',
      }),
      providesTags: ['statusType'],
    }),
    createNewStatusType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'POST',
        path: 'StatusTypes',
      }),
      invalidatesTags: ['statusType'],
    }),
    updateStatusType: builder.mutation({
      query: ({ data }) => ({
        data,
        method: 'PUT',
        path: 'StatusTypes',
      }),
      invalidatesTags: ['statusType'],
    }),
    deleteStatusType: builder.mutation({
      query: ({ id }) => ({
        method: 'DELETE',
        path: `StatusTypes/${id}`,
      }),
      invalidatesTags: ['statusType'],
    }),
  }),
});
export const statusTypeApiReducerName = statusTypeApi.reducerPath;
export const statusTypeApiReducer = statusTypeApi.reducer;
export const statusTypeApiMiddleware = statusTypeApi.middleware;

export const {
  useGetStatusTypeListQuery,
  useCreateNewStatusTypeMutation,
  useUpdateStatusTypeMutation,
  useDeleteStatusTypeMutation,
} = statusTypeApi;
